import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

type Props = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
  iconBg: string;
  iconColor?: string;
  onClick: () => void;
};

export default function QuickActionTile({
  icon,
  title,
  description,
  iconBg,
  iconColor = 'gray.800',
  onClick,
}: Props) {
  return (
    <Flex
      as='button'
      type='button'
      onClick={onClick}
      align='center'
      gap={3}
      p={3.5}
      borderWidth={1}
      borderColor='gray.200'
      borderRadius='xl'
      bg='white'
      textAlign='left'
      width='100%'
      transition='all 0.18s ease'
      shadow='0 1px 2px rgba(15,23,42,0.04)'
      _hover={{
        borderColor: 'gray.300',
        shadow: '0 8px 24px rgba(15,23,42,0.08)',
        transform: 'translateY(-2px)',
      }}
      _active={{ transform: 'translateY(0)' }}
    >
      <Flex
        align='center'
        justify='center'
        w={10}
        h={10}
        borderRadius='lg'
        bg={iconBg}
        flexShrink={0}
        position='relative'
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 'lg',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 60%)',
          pointerEvents: 'none',
        }}
      >
        <Icon as={icon} w={5} h={5} color={iconColor} />
      </Flex>
      <Box flex='1' minW={0}>
        <Text fontSize='sm' fontWeight='semibold' color='gray.900' lineHeight={1.2}>
          {title}
        </Text>
        <Text fontSize='xs' color='gray.500' mt={0.5} lineHeight={1.35}>
          {description}
        </Text>
      </Box>
      <Icon as={ChevronRightIcon} w={4} h={4} color='gray.400' flexShrink={0} />
    </Flex>
  );
}
